import React from 'react'
import Color from 'color'
import { Presence } from 'phoenix'
import { Icon } from '../common/components/Icon'
import orderBy from 'lodash/orderBy'
import { Icons } from '@botsquad/web-client'

import Link from './Link'
import { newGroup, dateTimeFormat } from '../common/util'
import { fixedLabel, resolveTranslations } from '../common/labels'
import { conversationTitle, conversationAvatar } from '../common/conversations'

export default class extends React.Component {
  buttonLink(button, idx) {
    switch (button.type) {
      case 'conversation':
        return '/b/' + idx + document.location.search
      case 'web_url':
        return button.url
    }
  }

  tr(value) {
    return resolveTranslations(value, this.props.locale, this.props.bot)
  }

  getHomeButtons() {
    const { bot } = this.props
    return bot.pwa.start_screen.home_buttons || []
  }

  renderMainButtons() {
    // ensures only the first button of a group gets the number indicator
    const { conversations } = this.props
    const buttons = this.getHomeButtons()
    if (!buttons.length) return null

    const counts = {}
    conversations.forEach(({ g, unread_message_count }) => {
      counts[g] = unread_message_count
    })

    return (
      <div className="buttons">
        {buttons.map((button, idx) => (
          <Link to={this.buttonLink(button, idx)} key={idx} className="button">
            {counts[button.g || 'main'] > 0 && (idx == 0 || (button.g || 'main') !== 'main') ? (
              <div className="button-count">{counts[button.g || 'main']}</div>
            ) : null}
            <div className="circle" style={button.image_url ? { backgroundImage: `url(${button.image_url})` } : null}>
              {button.icon ? <Icon>{button.icon}</Icon> : null}
            </div>
            <div className="text">{this.tr(button.title)}</div>
          </Link>
        ))}
      </div>
    )
  }

  renderNewConversationButton() {
    const { bot } = this.props
    if (!bot.pwa.start_screen.new_conversation_button) return null

    return (
      <div className="conversations">
        <Link to={'/g/' + newGroup()} className="new-conversation">
          {this.tr(bot.pwa.start_screen.new_conversation_button_label) ||
            fixedLabel('new_conversation', [this.props.locale])}
        </Link>
      </div>
    )
  }

  confirmClose = (e, g) => {
    e.stopPropagation()
    e.preventDefault()
    if (confirm('Archive this conversation?')) {
      this.props.conversationManager.closeConversation(g)
    }
  }

  renderConversations() {
    const { bot, operators } = this.props
    const buttonGroups = this.getHomeButtons()
      .map(({ g }) => g || 'main')
      .concat('intro')
    let conversations = this.props.conversations.filter(({ g }) => buttonGroups.indexOf(g) === -1)
    if (!conversations.length) return null

    return (
      <div className="conversations">
        {conversations.map((c, idx) => (
          <Link to={'/g/' + c.g + document.location.search} key={idx} className="conversation">
            {conversationAvatar(c.conversation_data, bot, operators)}
            <div className="meta">
              <div>{conversationTitle(c.conversation_data, bot)}</div>
              <div className="sub">{c.last_message || '…'}</div>
            </div>
            {c.unread_message_count > 0 ? <span className="button-count">{c.unread_message_count}</span> : null}
            <div className="close" onClick={e => this.confirmClose(e, c.g)}>
              {Icons.Close}
            </div>
          </Link>
        ))}
      </div>
    )
  }

  render() {
    const { bot } = this.props

    const mainColor = Color(bot.pwa.manifest.theme_color)
    const start_screen = bot.pwa.start_screen

    return (
      <div
        className={`main-menu--wrapper ${mainColor.isLight() ? 'light' : 'dark'}`}
        style={{ backgroundColor: mainColor }}
      >
        <div className="top" />
        <div className="header">
          <div className="avatar" style={{ backgroundImage: `url(${bot.profile_picture})` }} />
          <h1>
            <span dangerouslySetInnerHTML={{ __html: this.tr(start_screen.title) || bot.title }} />
          </h1>
          <p dangerouslySetInnerHTML={{ __html: this.tr(start_screen.description) || bot.purpose }} />
        </div>
        {this.renderMainButtons()}
        {this.renderNewConversationButton()}
        {this.renderConversations()}
      </div>
    )
  }
}
